<template>
  <div class="back">
    <div class="container">
      <!-- 登陆区 -->
      <el-form ref="ruleForm"
               label-width="0px"
               class="formClass"
               :rules="rules"
               :model="ruleForm">
          <div class="title"><img width="60px" height="60px" style="vertical-align: middle;" src="../assets/logo.png">道宏ai后台管理系统</div>
        <el-form-item prop="username">
          <el-input prefix-icon="el-icon-s-custom" placeholder="请输入用户名"
                    v-model="ruleForm.username"></el-input>
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="ruleForm.password" placeholder="请输入密码"
                    type="password" @keyup.enter.native="login('ruleForm')"
                    prefix-icon="el-icon-lock"></el-input>
        </el-form-item>
        <el-checkbox class="isSave" v-model="checked">记住用户名和密码</el-checkbox>
        <el-form-item class="btn">
          <el-button type="primary" 
                     @click="login('ruleForm')">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { encryptData, decryptData } from '@/utils/cryptofn.js'
import store from '@/store'
import { loginAdmin } from '@/api/admin.js'
import {  getUserTreeRight } from '@/api/right.js'
export default {
  data () {
    return {
      checked: true,
      multipleSelection: [],
      input: '',
      ruleForm: {
      },
      rules: {
        username: [
          {
            required: true,
            message: '请输入您的用户名',
            trigger: 'blur'
          },
          {
            min: 0,
            max: 20,
            message: '用户名长度在',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入您的密码',
            trigger: 'blur'
          },
          {
            min: 0,
            max: 39,
            message: '密码在0到39个字符',
            trigger: 'blur'
          }
        ],
        flag:false
      }
    }
  },
  mounted(){
    this.loadSavedCredentials();
  },
  methods: {
    loadSavedCredentials() {
      const savedUsername = localStorage.getItem('saved_username');
      const checked = localStorage.getItem('saved_state');
      if (savedUsername) {
        this.$set(this.ruleForm,'username',savedUsername)
        const savedPassword = localStorage.getItem('saved_password');
        if (savedPassword) {
          const deData = decryptData(savedPassword)
          // 转json格式
          const endData = JSON.parse(deData)
          this.$set(this.ruleForm,'password',endData)
        }
      }
        if (checked=="true") {
          this.checked = true
        }else if(checked=="false"){
          this.checked = false
        }
      
    },
    //登录实现
    login (formName) {
      
      store.commit('changeFlag404',false); 
      store.commit('changeFlagToT')
      // sessionStorage.removeItem('menu')
      store.commit('clearMenu')
      this.$refs[formName].validate(async (val) => {
        if (!val) {
          this.$message.error('输入的信息有误，请重新输入')
          return
        }
        const [res, err] = await loginAdmin(this.ruleForm)
        
        if (res?.data.Code == 1) {
          
          if(this.checked){
            this.ruleForm.password = encryptData(this.ruleForm.password)
            localStorage.setItem('saved_username', this.ruleForm.username);
            localStorage.setItem('saved_password', this.ruleForm.password);
            localStorage.setItem('saved_state', this.checked);
            
          }else{
            localStorage.removeItem('saved_username');
            localStorage.removeItem('saved_password');
            localStorage.setItem('saved_state', this.checked);
          }
          //保存token
          localStorage.setItem('Name',res.data.Data.RealName)
          localStorage.setItem('corrent',JSON.stringify(res.data.Data))
          localStorage.setItem('Token', res.data.Data.Token)
          // 登录之后通过真实姓名查找总体用户信息查询到该用户的id，通过用户id获取用户角色id
          // let currentId;
          // currentId = res.data.Data.UserId
          // if (currentId) {
            // const [res2, err2] = await getUserTreeRight(currentId)
            // let userRoleId = res2.data.Data
            // store.commit('updateMenus', userRoleId)
            // localStorage.setItem('allmenus', JSON.stringify(userRoleId))
            // store.commit('changeUserMenus', userRoleId);
            if(this.$route.query.redirect){
              // debugger
              this.$router.push(this.$route.query.redirect);
            }else{
              this.$router.push("/sys/admin");
            }
          }
          //跳转到home组件
          if(res.data.Code == 3){
          
          }

      })
    }
  }
}
</script>

<style scoped>
.title{
  font-size: 20px;
  font-weight: bold;
  margin-bottom: 13px;
  margin-left: -135px;
}
::v-deep .has-gutter .el-table_1_column_1 .el-checkbox {
  display: none;
}
/* 图片区样式开始 */
.container {
  background-color: #fff;
  height: 330px;
  width: 400px;
  border-radius: 10px;
  position: absolute;
  left: 80%;
  top: 52%;
  transform: translate(-50%, -50%);
}
/* .logo {
  width: 120px;
  height: 120px;
  border: 11px solid #fff;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #eeeeee;
  background-clip: content-box;
  overflow: hidden;
  box-shadow: #ddd 0px 0px 10px;
} */
.back {
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: url('../assets/main1.png');
  /* width: 100%; */
  height:100%;
  background-size: cover;
}
/* 图片区样式结束 */
/* 登陆区样式开始 */
.formClass {
  width: 100%;
  position: absolute;
  top: 4%;
  left: 50%;
  transform: translate(-50%);
  box-sizing: border-box;
  padding: 0 40px;
}
.btn {
  display: flex;
  justify-content: center;
  /* width: 80%; */
}
>>>.el-form-item__content{
  width: 100%;
}
>>>.el-button{
  width: 100%;
}
.isSave{
  display: flex;
  margin-bottom: 20px;
}
/* 登陆区样式结束 */
</style>
